import { IState } from '../../../../store/types';
import { connect } from 'react-redux';
import { CallRecordingProgressModal } from '../components/CallRecordingProgressModal';
import { ICallRecordingProgressModalEvents, ICallRecordingProgressModalFields } from '../components/types';
import { ICallRecordingProgressModalHOCProps } from './types';

const mapStateToProps = (
	state: IState,
	{ open, title, progressLog, isProcessing, startedAt, stepStartedAt, updatedAt, audioId, settingsSection, actions }: ICallRecordingProgressModalHOCProps
): ICallRecordingProgressModalFields => ({
	actions,
	open,
	title,
	progressLog,
	isProcessing,
	startedAt,
	stepStartedAt,
	updatedAt,
	audioId,
	settingsSection,
});

const mapDispatchToProps = (
	dispatch: any,
	{ onClose, onProcess, onCancel }: ICallRecordingProgressModalHOCProps
): ICallRecordingProgressModalEvents => ({
	onClose,
	onProcess,
	onCancel,
});

export const CallRecordingProgressModalHOC = connect(
	mapStateToProps,
	mapDispatchToProps
)(CallRecordingProgressModal);

CallRecordingProgressModalHOC.displayName = 'CallRecordingProgressModalHOC';
